module.exports = __webpack_public_path__ + "media/images/preguntas-frecuentes-color-2550f95dc7f08014c84ffe7c50907719.png";